import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

const Header: FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string): void => {
    void i18n.changeLanguage(lng);
  };

  return (
    <div className="flex h-16 items-center justify-between bg-gradient-to-r from-[#0c2caf] to-[#c14cdf] px-6 text-white sm:px-10 md:h-20">
      <a target="blank" href="/">
        <img
          src="https://themindessence.com/wp-content/uploads/2024/10/Logo-Mono-Fondo-Morado.png"
          className="h-[34px] sm:h-[44px]"
          alt="Logo"
        />
      </a>
      <div className="flex items-center gap-4">
        <div className="flex gap-2 text-xs font-medium uppercase tracking-wider">
          <button
            onClick={() => {
              changeLanguage('es');
            }}
            className={`opacity-60 transition-opacity hover:opacity-100 ${
              i18n.language.startsWith('es')
                ? 'underline decoration-2 underline-offset-4 opacity-100'
                : ''
            }`}
          >
            ES
          </button>
          <span className="opacity-40">|</span>
          <button
            onClick={() => {
              changeLanguage('pt');
            }}
            className={`opacity-60 transition-opacity hover:opacity-100 ${
              i18n.language.startsWith('pt')
                ? 'underline decoration-2 underline-offset-4 opacity-100'
                : ''
            }`}
          >
            PT
          </button>
          <span className="opacity-40">|</span>
          <button
            onClick={() => {
              changeLanguage('en');
            }}
            className={`opacity-60 transition-opacity hover:opacity-100 ${
              i18n.language.startsWith('en')
                ? 'underline decoration-2 underline-offset-4 opacity-100'
                : ''
            }`}
          >
            EN
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
